const state = {
  code: 0,
  msg: {
    errorCode: 0,
    errorMessage: null
  }
};

const mutations = {
  SET_CODE: function(state, code) {
    state.code = code;
  },
  SET_MESSAGE: function(state, msg) {
    state.msg = msg;
  }
};

const actions = {
  async setCode({ commit }, { code }) {
    commit("SET_CODE", code);
  },
  async setMessage({ commit }, { msg }) {
    commit("SET_MESSAGE", msg);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
